import React from 'react';

function LoadingScreen({label = 'Loading Prepspire Vocabulary Trainer…'}) {
  return (
    <div className="loading-screen" role="status">
      <span className="loader" />
      <p>{label}</p>
    </div>
  );
}

export default LoadingScreen;